<template>
    <div class="interface-document" :class="{'disabled': disabled}">
        <div class="interface-document__editor">
            <tiny-mce :value="value" @input="change" :init="initOpt" :disabled="disabled"></tiny-mce>
        </div>
        <slot></slot>
    </div>
</template>

<script>
    import 'tinymce/tinymce.min.js'
    import 'tinymce/themes/modern/theme.min.js'
    import '@/libs/tinymce/language/ru.js'
    import 'tinymce/skins/lightgray/skin.min.css'
    import 'tinymce/skins/lightgray/content.min.css'

    import 'tinymce/plugins/autolink/plugin.min.js'
    import 'tinymce/plugins/directionality/plugin.min.js'
    import 'tinymce/plugins/visualblocks/plugin.min.js'
    import 'tinymce/plugins/visualchars/plugin.min.js'
    import 'tinymce/plugins/table/plugin.min.js'
    import 'tinymce/plugins/charmap/plugin.min.js'
    import 'tinymce/plugins/hr/plugin.min.js'
    import 'tinymce/plugins/charmap/plugin.min.js'
    import 'tinymce/plugins/pagebreak/plugin.min.js'
    import 'tinymce/plugins/nonbreaking/plugin.min.js'
    import 'tinymce/plugins/anchor/plugin.min.js'
    import 'tinymce/plugins/toc/plugin.min.js'
    import 'tinymce/plugins/insertdatetime/plugin.min.js'
    import 'tinymce/plugins/advlist/plugin.min.js'
    import 'tinymce/plugins/lists/plugin.min.js'
    import 'tinymce/plugins/textcolor/plugin.min.js'
    import 'tinymce/plugins/wordcount/plugin.min.js'
    import 'tinymce/plugins/imagetools/plugin.min.js'
    import 'tinymce/plugins/contextmenu/plugin.min.js'
    import 'tinymce/plugins/colorpicker/plugin.min.js'
    import 'tinymce/plugins/textpattern/plugin.min.js'

    import TinyMce from '@tinymce/tinymce-vue'

    export default {
        name: 'interface-document',
        components: {
            TinyMce
        },
        props: {
            value: String,
            options: {
                type: Object,
                default: () => {}
            },
            disabled: Boolean
        },
        methods: {
            change (val) {
                this.$emit('input', val)
            }
        },
        data () {
            return {
                val: '',
                defaultOpt: {
                    height: '400',
                    language: 'ru',
                    plugins: 'autolink directionality visualblocks visualchars table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount imagetools contextmenu colorpicker textpattern'
                }
            }
        },
        computed: {
            initOpt () {
                return {
                    ...this.defaultOpt,
                    ...this.options
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .interface-document {
        position relative

        &.disabled &__editor {
            pointer-events none
        }
    }
</style>
